import { HttpErrorResponse } from '@angular/common/http';
import {
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Injector,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ViewBuildingAlarmsExtendedInfo1Dto } from '@app/energy-guard/models/ViewBuildingAlarmsExtendedInfo1';
import { AlarmsService } from '@app/energy-guard/services/alarms.service';
import { BuildingsService } from '@app/energy-guard/services/buildings.service';
import { StreetLightPlannerSidebarScenarioComponent } from '@app/energy-map/components/street-light-planner-sidebar-scenario/street-light-planner-sidebar-scenario.component';
import { EnergyMapService } from '@app/energy-map/services/energy-map-service';
import { SensorMapMarkersService } from '@app/sensordaten/services/sensor-map-markers.service';
import { Recommendation } from '@app/shared/constants';
import { NotificationDialogComponent } from '@app/shared/dialog/notification-dialog/notification-dialog.component';
import { HttpStatusCodes } from '@app/shared/enums';
import { BuildingTypes } from '@app/shared/models/building-types';
import { EnergyMarker, EnergyTypeMarker, EPMarker } from '@app/shared/models/energiekarte/epmarker';
import { Luminaire } from '@app/shared/models/energiekarte/luminaire';
import { RecommendationsDto, ScenarioPlannerResponseDto } from '@app/shared/models/scenario-planner';
import { NotificationsService } from '@app/shared/notifications/notifications.service';
import { ConsumersService } from '@app/shared/services/api/consumers.service';
import { StreetlightApiService } from '@app/shared/services/api/streetlight.service';
import { AuthService } from '@app/shared/services/auth.service';
import { FeatureDurationLoggerService } from '@app/shared/services/feature-duration-logger.service';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { StringUtility } from '@app/shared/string-utility';
import { cssVariables } from '@env/css-vars';
import { TranslateService } from '@ngx-translate/core';
import * as L from 'leaflet';
import 'leaflet-area-select';
import 'leaflet.markercluster';
import { assign, compact, concat, find, forEach, get, isEqual, isNil, orderBy, some, uniqBy } from 'lodash';
import { forkJoin, merge, Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { catchError, filter, finalize, first, map as rxjsMap, mergeMap, switchMap, takeUntil, tap, distinctUntilChanged } from 'rxjs/operators';
import { AddressSearchService } from '../shared/services/api/address-search.service';
import { BuildingTypesService } from '../shared/services/api/building-types.services';
import { ScenarioPlannerService } from '../shared/services/api/scenario-planner.service';
import { SidebarService } from '../shared/services/sidebar.service';
import { NewLegendsService } from './components-new/legends/new-legends.service';
import { MapHeaderControlsService } from './components-new/map-header-controls/map-header-controls.service';
import { BuildingIconComponent } from './components/building-icon/building-icon.component';
import { ScenarioPanelComponent } from './components/scenario-panel/scenario-panel.component';
import { MapStoreMunicipality } from '../shared/models/municipality/Municipality';
import { StreetlightLayerService } from './map-layers/streetlight-layer.service';
import { BuildingsStoreService } from './services/buildings-store.service';
import { LampsSelectedService } from './services/lamps-selected.service';
import { MapStoreService } from './services/map-store.service';
import { MapService } from './services/map.service';
import { MeterBuildingAlarm } from '@app/energy-guard/models/alarms';
import { EnergyMapBuilding } from '@app/shared/models/energiekarte/energy-map-building';
import { NullableBoolean } from '@app/shared/models/nullable';
import * as moment from 'moment';
import { ProducersService } from '@app/shared/services/api/producer.service';
import { ProducerLayerService } from './map-layers/producer-layer.service';

@Component({
  selector: 'app-energy-map-new',
  templateUrl: './energy-map.component.html',
  styleUrls: ['./energy-map.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EnergyMapComponent implements OnInit, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  public showDescription = false;
  public selectedMarkers: any[] = [];
  public isScenarioEdited = false;
  public IsEditBuilding = false;
  public municipalityToSearch: MapStoreMunicipality = {} as MapStoreMunicipality;
  public isLoading = false;
  public isMunicipalityEnergyGuardLicensed: boolean = false;
  private isDescriptionVisibleSubscription: Subscription;
  private scenarioPlannerEditedSubscription: Subscription;
  private municipalityChangedSubscription: Subscription;
  private pinLocationMarker?: L.Marker<any>;
  private iconsUrl = `/assets/icons/objectTypes/`;
  @ViewChild('mapContainer', { static: true }) private mapContainer!: ElementRef;

  constructor(
    public applicationRef: ApplicationRef,
    public energyMapService: EnergyMapService,
    public injector: Injector,
    public matDialog: MatDialog,
    public resolver: ComponentFactoryResolver,
    public translate: TranslateService,
    private readonly addressSearchService: AddressSearchService,
    private readonly alarmsService: AlarmsService,
    private readonly authService: AuthService,
    private readonly buildingService: BuildingsService,
    private readonly buildingsStoreService: BuildingsStoreService,
    private readonly buildingTypeService: BuildingTypesService,
    private readonly consumersService: ConsumersService,
    private readonly iotSensorMarkerService: SensorMapMarkersService,
    private readonly lampsSelectedService: LampsSelectedService,
    private readonly legendsService: NewLegendsService,
    private readonly mapHeaderControlsService: MapHeaderControlsService,
    private readonly mapService: MapService,
    private readonly mapStoreService: MapStoreService,
    private readonly notificationService: NotificationsService,
    private readonly overlayLoaderService: OverlayLoaderService,
    private readonly route: ActivatedRoute,
    private readonly scenarioPlannerService: ScenarioPlannerService,
    private readonly sidebarService: SidebarService,
    private readonly streetlightLayerService: StreetlightLayerService,
    private readonly streetlightsService: StreetlightApiService,
    private readonly subfeatureDurationLoggerService: FeatureDurationLoggerService,
    private readonly userMunicipalitiesService: UserMunicipalitiesService,
    private readonly producersService: ProducersService,
    private readonly producerLayerService: ProducerLayerService,
  ) {
    this.overlayLoaderService.isGlobalLoader = false;

    this.scenarioPlannerEditedSubscription = this.energyMapService.scenarioPlannerEdited$.subscribe((edited) => {
      this.isScenarioEdited = edited;
    });

    this.municipalityChangedSubscription = this.energyMapService.muninicipalityChanged$.subscribe((changed) => {
      if (changed) {
        this.showDescription = false;
        this.removeSelectedBuilding();
      }
    });

    this.lampsSelectedService.lampRemoved
      .pipe(
        mergeMap(
          (i) =>
            of(i).pipe(
              tap((selectedLamp: any) => {
                const marker = this.mapStoreService.lampMarkers.find((selectedMarker) => selectedMarker.options.data.equipment === selectedLamp.equipment);

                if (marker) {
                  marker.options.data.lamps.forEach((lamp: any) => {
                    if (lamp.assetId === selectedLamp.assetId) {
                      lamp.selected = false;
                      this.mapService.setClassLamp(marker, {
                        isSelected: false,
                        isHighlighted: false,
                      });
                    }
                  });
                  if (marker.options.data.hasMultipleLamps) {
                    const selectedLamps = marker.options.data.lamps.find((lamp: any) => lamp.selected === true);
                    if (selectedLamps) {
                      this.mapService.setClassLamp(marker, {
                        isSelected: true,
                        isHighlighted: false,
                      });
                    } else {
                      this.mapService.setClassLamp(marker, {
                        isSelected: false,
                        isHighlighted: false,
                      });
                    }
                  }
                }
              }),
            ),
          2,
        ),
        takeUntil(this.unsubscribe$),
      )
      .subscribe();

    this.lampsSelectedService.lampAdded.pipe(takeUntil(this.unsubscribe$)).subscribe((selectedLamp: any) => {
      const marker = this.mapStoreService.lampMarkers.find((selectedMarker) => selectedMarker.options.data.equipment === selectedLamp.equipment);
      if (marker) {
        this.mapService.setClassLamp(marker, {
          isSelected: true,
          isHighlighted: false,
        });
      }
    });

    this.isDescriptionVisibleSubscription = this.iotSensorMarkerService.isDescriptionVisible.subscribe(() => {
      this.showDescription = this.iotSensorMarkerService.selectedMarkers.length > 0;
      this.selectedMarkers = this.iotSensorMarkerService.selectedMarkers;
    });
  }

  public ngOnInit(): void {
    this.userMunicipalitiesService.currentMunicipality$
      .pipe(
        filter((municipality: MapStoreMunicipality) => !!municipality?.guid && !!municipality?.key),
        distinctUntilChanged(),
        switchMap((municipality: MapStoreMunicipality) => {
          this.municipalityToSearch = municipality;
          return this.alarmsService.getLicensedMetersCount(municipality.key);
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((licensedMeters: number) => (this.isMunicipalityEnergyGuardLicensed = licensedMeters !== 0));

    this.subfeatureDurationLoggerService.initializeApplicationInsights('Energiekarte');

    this.initializeMap();
    this.initializeVariables();

    const scenarioId: string | null = this.route.snapshot.paramMap.get('id');
    if (scenarioId) {
      this.loadScenario(scenarioId);
    } else {
      this.loadEnergyMap();
    }

    if (this.route.snapshot.queryParamMap.get('salesTool') === 'true' && this.authService.permissions.STREETLIGHT_PLANNER) {
      this.sidebarService.showComponent(StreetLightPlannerSidebarScenarioComponent);
    }

    if (this.route.snapshot.queryParamMap.get('action') === 'openBuildingMenu') {
      setTimeout(() => {
        this.mapHeaderControlsService.openBuildingMenu();
      }, 2000);
    }
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.subfeatureDurationLoggerService.unsubscribbe();
    this.sidebarService.destroyComponent();
    this.notificationService.destroy();
    this.mapService.selectMode(false);
    this.scenarioPlannerEditedSubscription.unsubscribe();
    this.municipalityChangedSubscription.unsubscribe();
    this.isDescriptionVisibleSubscription.unsubscribe();
    this.iotSensorMarkerService.activeSensor = null;
  }

  private initializeVariables(): void {
    this.mapStoreService.updateConsumerCluster(
      L.markerClusterGroup({
        spiderfyOnMaxZoom: false,
        iconCreateFunction: this.createClusterMarkerIcon,
      }),
    );
    this.mapStoreService.updateStreetLightCluster(
      L.markerClusterGroup({
        iconCreateFunction: this.streetlightLayerService.getLampClusterIcon.bind(this),
      }),
    );
    this.mapStoreService.updateStreetLightHeatmap(L.layerGroup());
    this.mapStoreService.updateLampMarker();
    this.selectedMarkers = [];
  }

  private createClusterMarkerIcon(markers: any): L.DivIcon {
    return L.divIcon({
      className: 'custom-div-icon',
      html: `<div class='marker-pin'><div class='marker-pin-count'>${markers.getChildCount()}</div></div>`,
      iconSize: [30, 42],
      iconAnchor: [15, 42],
    });
  }

  private addClusterEvent(cluster: any): void {
    cluster.on('clusterclick', (e: any) => {
      if ((this.mapStoreService.map as L.Map).getZoom() === this.mapStoreService.zoom.maxZoom) {
        const modifiedMarker: any[] = [];

        forEach(e.layer.getAllChildMarkers(), (clusterMarker) => {
          const childMarker = get(clusterMarker, 'options.data');
          modifiedMarker.push(childMarker);
        });
        if (this.showDescription && isEqual(modifiedMarker, this.selectedMarkers)) {
          this.removeSelectedBuilding();
          this.showDescription = false;
          return;
        }
        this.selectedMarkers = orderBy(modifiedMarker, 'type');
        this.showDescription = true;
      }
    });

    cluster.on('click', (e: any) => {
      this.buildingsStoreService.selectedBuildingWithUnkownTypeOrGps$
        .pipe(
          filter((x) => isNil(x)),
          first(),
        )
        .subscribe(() => {
          this.openBuildingDialog(e.layer.options.data.guid);
        });
    });
  }

  private createImageIcon(image: string): L.Icon {
    return L.icon({
      iconUrl: image,
      shadowSize: [60, 60],
      iconAnchor: this.mapStoreService.defaultIconAnchor,
      shadowAnchor: [20, 40],
      popupAnchor: [0, -53],
    });
  }

  private createBuildingIconComponent(): ComponentRef<BuildingIconComponent> {
    return this.resolver.resolveComponentFactory(BuildingIconComponent).create(this.injector);
  }

  private resetLampAssets(): void {
    this.mapStoreService.updateLampMarker();
    if (!isNil(this.mapStoreService.streetLightCluster)) {
      (this.mapStoreService.map as L.Map).removeLayer(this.mapStoreService.streetLightCluster);
    }
    if (!isNil(this.mapStoreService.streetLightHeatmap)) {
      (this.mapStoreService.map as L.Map).removeLayer(this.mapStoreService.streetLightHeatmap);
    }
  }

  private resetEnergyAssets(): void {
    if (!isNil(this.mapStoreService.consumerCluster)) {
      (this.mapStoreService.map as L.Map).removeLayer(this.mapStoreService.consumerCluster);
    }
    this.mapStoreService.updateConsumerMarker();
  }

  private resetProducerMarkers(): void {
    const clusters = [
      this.mapStoreService.photovoltaicCluster,
      this.mapStoreService.biomasseCluster,
      this.mapStoreService.waterCluster,
      this.mapStoreService.windCluster,
    ];

    clusters.forEach((cluster) => {
      if (cluster) {
        (this.mapStoreService.map as L.Map).removeLayer(cluster);
      }
    });
  }

  public refreshClusters(asset: any): void {
    if (asset.type === 'consumer') {
      const imageName = get(asset, 'buildingType.imageName', 'Keine-daten-vorhanden.svg');
      asset.icon = `${this.iconsUrl}${imageName}`;
    }

    if (this.selectedMarkers.length === 1 && !isNil(asset.marker)) {
      const icon = asset.type === 'consumer' ? this.updateComponentIcon(asset) : this.createImageIcon(asset.icon);
      asset.marker.setIcon(icon);
    }
  }

  private updateComponentIcon(asset: any): L.DivIcon {
    asset.component.instance.iconImageUrl = asset.icon;
    asset.component.instance.heatColorStatus = asset.heatColorStatus;
    asset.component.instance.electricityColorStatus = asset.electricityColorStatus;

    asset.component.changeDetectorRef.detectChanges();
    return new L.DivIcon({
      html: asset.component.location.nativeElement,
      iconSize: this.mapStoreService.defaultIconSize,
      iconAnchor: [50, 120],
      popupAnchor: [0, -53],
    });
  }

  public removeSelectedBuilding(): void {
    this.iotSensorMarkerService.selectedMarkers = [];
  }

  private initializeMap(): void {
    const map = L.map(this.mapContainer.nativeElement, {
      zoomControl: false,
      minZoom: this.mapStoreService.zoom.minZoom,
      maxZoom: this.mapStoreService.zoom.maxZoom,
      attributionControl: true,
    });
    map.attributionControl.setPrefix('');
    map.attributionControl.addAttribution(`© basemap.de / BKG ${moment().year()}`);

    this.mapStoreService.updateMap(map);

    const osm = this.mapStoreService.streetTileLayer;

    (this.mapStoreService.map as L.Map).addLayer(osm);

    L.control
      .zoom({
        position: 'bottomright',
      })
      .addTo(this.mapStoreService.map as L.Map);

    this.mapStoreService.loadTileLayer();

    this.streetlightLayerService.initializeAreaSelect();
  }

  private loadEnergyMap(): void {
    this.authService.permissionLoadComplete$
      .asObservable()
      .pipe(
        filter((isLoaded: boolean) => isLoaded),
        switchMap(() => this.userMunicipalitiesService.currentMunicipality$),
        filter((municipality: MapStoreMunicipality) => !!municipality?.guid && !!municipality?.key),
        distinctUntilChanged(),
        switchMap((municipality: MapStoreMunicipality) => {
          this.overlayLoaderService.isLoading = true;
          this.overlayLoaderService.ignoreChanges = true;

          this.resetLampAssets();
          this.resetEnergyAssets();
          this.resetProducerMarkers();
          this.initializeVariables();
          return forkJoin([
            this.loadStreetlightMarkers$(municipality.key),
            this.loadConsumerMarkers$(municipality.key),
            this.iotSensorMarkerService.load(municipality.guid),
            this.loadProducerMarkers$(municipality.key),
          ]);
        }),
        catchError((error: Error | HttpErrorResponse) => {
          this.overlayLoaderService.setLoadingToFalse();
          return throwError(() => error);
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(() => {
        this.navigateByMarkers();
        this.restorePageState();
        setTimeout(() => {
          this.overlayLoaderService.setLoadingToFalse();
        }, 2500);
      });
  }

  private restorePageState(): void {
    const state = this.route.snapshot.queryParamMap.get('returnstate');

    switch (state) {
      case 'openbuildingdialog':
        this.openBuildingDialog(this.route.snapshot.queryParamMap.get('buildingid'));
        break;
      case 'opensensormarkerdialog':
        this.overlayLoaderService.isGlobalLoader = false;
        this.isLoading = true;
        this.iotSensorMarkerService.showIoTMarkers();
        this.legendsService.updatePreferences({ isIotVisible: true });
        this.openSensorMarkerDialog(this.route.snapshot.queryParamMap.get('deviceEUI'));
        break;
    }
  }

  private openBuildingDialog(buildingId: string | null): void {
    if (isNil(buildingId)) {
      return;
    }

    const buildingMarker = this.mapStoreService.getConsumerMarkerById(buildingId);

    if (isNil(buildingMarker)) {
      return;
    }

    const building = buildingMarker.options.data;

    (this.mapStoreService.map as L.Map).setView(new L.LatLng(building.latitude, building.longitude), this.mapStoreService.zoom.maxZoom);

    if (this.authService.permissions.ENERGY_GUARD && this.isMunicipalityEnergyGuardLicensed) {
      this.buildingService
        .getLicensedMetersByConnectionObjectNumber(building.connectionObjectNumber)
        .pipe(
          catchError(() => of([] as ViewBuildingAlarmsExtendedInfo1Dto[])),
          takeUntil(this.unsubscribe$),
        )
        .subscribe((res: ViewBuildingAlarmsExtendedInfo1Dto[]) => {
          assign(building, {
            isBuildingEnergyGuardLicensed: res.length > 0,
            isMunicipalityEnergyGuardLicensed: this.isMunicipalityEnergyGuardLicensed,
          });
          this.selectedMarkers = [building];
          this.showDescription = true;
        });
    } else {
      assign(building, {
        isBuildingEnergyGuardLicensed: false,
        isMunicipalityEnergyGuardLicensed: false,
      });
      this.selectedMarkers = [building];
      this.showDescription = true;
    }
  }

  private openSensorMarkerDialog(deviceEUI: string | null): void {
    if (isNil(deviceEUI)) {
      this.overlayLoaderService.isGlobalLoader = true;
      this.isLoading = false;
      return;
    }

    this.mapStoreService.sensorMarkers$
      .pipe(
        filter((data) => !!data),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(() => {
        const sensorMarker = this.mapStoreService.getSensorMarkerById(deviceEUI);

        if (isNil(sensorMarker)) {
          this.overlayLoaderService.isGlobalLoader = true;
          this.isLoading = false;
          return;
        }

        const sensor = sensorMarker;
        this.iotSensorMarkerService.activeSensor = sensor;

        (this.mapStoreService.map as L.Map).setView(new L.LatLng(sensor.latlang[0], sensor.latlang[1]), this.mapStoreService.zoom.maxZoom);

        const sensors = this.mapStoreService.getSensorsByCoord(sensor.latlang[0], sensor.latlang[1]);

        if (sensors.length > 0) {
          this.overlayLoaderService.isGlobalLoader = true;
          this.isLoading = false;
        }

        this.selectedMarkers = sensors;
        this.showDescription = true;
      });
  }

  private loadScenario(id: string): void {
    this.overlayLoaderService.isLoading = true;
    this.overlayLoaderService.ignoreChanges = true;

    let tempScenario: ScenarioPlannerResponseDto;

    this.scenarioPlannerService
      .getById(id)
      .pipe(
        rxjsMap((scenario: ScenarioPlannerResponseDto): ScenarioPlannerResponseDto => {
          scenario = {
            ...scenario,
            recommendations: orderBy(scenario.recommendations, (recommendation: RecommendationsDto) => recommendation.isRecommended, ['desc']),
          };
          return scenario;
        }),
        switchMap((scenario: ScenarioPlannerResponseDto) => {
          tempScenario = scenario;
          this.resetLampAssets();
          this.resetEnergyAssets();
          this.initializeVariables();

          const municipality = this.userMunicipalitiesService.municipalities.find((a: MapStoreMunicipality) =>
            StringUtility.areStringsIdentical(a.key, scenario.municipalityKey),
          );

          if (municipality) {
            this.userMunicipalitiesService.updateMunicipality(municipality);
          }

          return forkJoin([
            this.loadStreetlightMarkers$(scenario.municipalityKey),
            this.loadConsumerMarkers$(scenario.municipalityKey),
            this.iotSensorMarkerService.load(scenario.municipalityGuid),
          ]);
        }),
        catchError((error: Error | HttpErrorResponse) => throwError(() => error)),
        finalize(() => this.overlayLoaderService.setLoadingToFalse()),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(() => {
        this.loadScenarioDetails(tempScenario);
        this.navigateByMarkers();
      });
  }

  private loadScenarioDetails(scenario: ScenarioPlannerResponseDto): void {
    this.lampsSelectedService.addLamps(scenario.recommendations);

    const data = {
      plannerScenarioId: scenario.id,
      name: scenario.name,
      budget: scenario.budget,
      recommendationTypeId: scenario.type,
      recommendationType: find(Recommendation, (value) => StringUtility.areStringsIdentical(value.id, scenario.type))?.type,
    };

    if (data.recommendationType === 'Manual') {
      scenario.recommendations.forEach((element) => {
        const selectedLamp = find(this.mapStoreService.lampMarkers, (marker) => marker.options.data.equipment === element.equipment);
        if (!isNil(selectedLamp)) {
          this.mapService.setClassLamp(selectedLamp, {
            isSelected: true,
            isHighlighted: selectedLamp.options.isHighlighted,
          });
        }
      });
    }

    this.sidebarService.showComponent(ScenarioPanelComponent, data);

    if (some(scenario.recommendations, (r) => isNil(r.suggestedModel))) {
      this.matDialog.open(NotificationDialogComponent, {
        data: {
          descriptionText: `Mindestens ein Produkt in Ihrem Szenario ist nicht mehr Bestandteil unseres Produktkataloges.
            Bitte wählen Sie eine andere Leuchte aus.`,
          confirmText: 'Ok',
        },
        panelClass: ['-md'],
      });
    }
  }

  private loadStreetlightMarkers$(municipalityKey: string): Observable<NullableBoolean> {
    if (!this.authService.permissions.ENERGY_MAP_STREETLIGHTS) {
      return of(null);
    }

    return this.streetlightsService.getLuminairesByMunicipalityKey(municipalityKey).pipe(
      switchMap((luminaires: Luminaire[]) => this.streetlightLayerService.initializeLamps(luminaires)),
      tap((isDone: boolean) => {
        if (isDone) {
          this.legendsService.toggleStreetlightsLayer();
        }
      }),
      catchError(() => of(null)),
    );
  }

  private loadProducerMarkers$(municipalityKey: string): Observable<EnergyTypeMarker[]> {
    return this.producersService.getProducersByMunicipalityKey(municipalityKey).pipe(
      catchError(() => of([])),
      tap((producers) => {
        this.producerLayerService.clearMarkers();
        this.producerLayerService.initializeProducers(producers);
      }),
      first(),
    );
  }

  private loadConsumerMarkers$(municipalityKey: string): Observable<[EnergyMapBuilding[], BuildingTypes[], ViewBuildingAlarmsExtendedInfo1Dto[]] | null> {
    if (!this.authService.permissions.ENERGY_MAP_CONSUMERS) {
      return of(null);
    }

    return forkJoin([
      this.consumersService.getByMunicipalityKeyOData(municipalityKey),
      this.buildingTypeService.getAll(),
      this.getBuildingAlarmsByMunicipality(municipalityKey),
    ]).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === HttpStatusCodes.notFound) {
          this.displayNoBuildingsMessage();
        }
        return throwError(() => error);
      }),
      tap(([consumers, buildingTypes, buildingAlarms]: [EnergyMapBuilding[], BuildingTypes[], ViewBuildingAlarmsExtendedInfo1Dto[]]) => {
        consumers = uniqBy(consumers, 'guid');
        if (consumers.length <= 0) {
          this.displayNoBuildingsMessage();
        } else {
          this.initializeConsumers(consumers || [], buildingTypes || [], buildingAlarms || []);
        }
      }),
    );
  }

  private displayNoBuildingsMessage(): void {
    this.matDialog.open(NotificationDialogComponent, {
      data: {
        descriptionText: this.translate.instant('module.energyMap.noBuildingsInMunicipalityMessage'),
        descriptionFaClass: 'fa-exclamation-triangle fa-2x',
        descriptionFaColor: cssVariables['--ep-error-color'],
      },
      position: { top: '40px' },
      panelClass: ['-md'],
    });
  }

  private initializeConsumers(consumers: EnergyMapBuilding[], buildingTypes: BuildingTypes[], alarms: ViewBuildingAlarmsExtendedInfo1Dto[]) {
    this.mapStoreService.updateConsumerCluster(
      L.markerClusterGroup({
        spiderfyOnMaxZoom: false,
        iconCreateFunction: this.createClusterMarkerIcon,
      }),
    );

    this.addClusterEvent(this.mapStoreService.consumerCluster);

    (this.mapStoreService.map as L.Map).addLayer(this.mapStoreService.consumerCluster);

    const markers: EnergyMarker[] = compact([...((consumers as EnergyMarker[]) || [])]);
    markers.forEach((energyMarker: EnergyMarker) => {
      energyMarker.type = 'consumer';

      this.mapImageNameToBuilding(energyMarker, buildingTypes);

      this.mapAlarmsToBuilding(energyMarker, alarms);

      const buildingIconComponent = this.createBuildingIconComponent();
      buildingIconComponent.instance.iconImageUrl = energyMarker.icon;

      this.energyGuard(energyMarker, buildingIconComponent);

      buildingIconComponent.instance.electricityColorStatus = energyMarker.efficiencyAnalyses?.[0]?.electricityColorStatus ?? '';
      buildingIconComponent.instance.heatColorStatus = energyMarker.efficiencyAnalyses?.[0]?.heatColorStatus ?? '';

      buildingIconComponent.changeDetectorRef.detectChanges();

      const icon = new L.DivIcon({
        html: buildingIconComponent.location.nativeElement,
        iconSize: this.mapStoreService.defaultIconSize,
        iconAnchor: [50, 120],
        popupAnchor: [0, -53],
      });

      const latitude = isNil(energyMarker.latitude) ? 0 : energyMarker.latitude;
      const longitude = isNil(energyMarker.longitude) ? 0 : energyMarker.longitude;

      const marker = new EPMarker([latitude, longitude], {
        icon: icon,
        id: energyMarker.guid,
        data: energyMarker,
        type: 'mapmarker',
      });

      energyMarker.marker = marker;
      energyMarker.component = buildingIconComponent;

      marker.addTo(this.mapStoreService.consumerCluster);
      this.mapStoreService.addConsumerMarker(marker);
    });

    this.legendsService.toggleConsumersLayer();
  }

  private mapAlarmsToBuilding(building: EnergyMarker, alarms: ViewBuildingAlarmsExtendedInfo1Dto[]): void {
    const buildingAlarm = alarms.find((alarm: ViewBuildingAlarmsExtendedInfo1Dto) => alarm.connectionObjectNumber === building.connectionObjectNumber);

    if (isNil(buildingAlarm)) {
      building.alarms = { alarmsCount: 0, isEnergyGuardLicenseAvailable: false } as MeterBuildingAlarm;
    } else {
      building.alarms = buildingAlarm as MeterBuildingAlarm;
    }
  }

  private mapImageNameToBuilding(building: EnergyMarker, buildingTypes: BuildingTypes[]): void {
    let imageName = '';

    if (isNil(building.buildingTypeId)) {
      imageName = 'cube-v2.png';
    } else {
      building.buildingType = buildingTypes.find((buildingType: BuildingTypes) => buildingType.guid === building.buildingTypeId) ?? null;
      imageName = building.buildingType ? building.buildingType.imageName : 'generic-building-gray.png';
    }

    building.icon = `${this.iconsUrl}${imageName}`;
  }

  private energyGuard(energyMarker: EnergyMarker, buildingIconComponent: ComponentRef<BuildingIconComponent>): void {
    if (this.authService.permissions.ENERGY_GUARD) {
      const shieldIconTranslation$ = this.translate.get('module.energyGuard.common.shieldIcon');

      const hasActiveAlarm$ = of(energyMarker.alarms.alarmsCount).pipe(
        filter((alarms) => alarms > 0 && energyMarker.alarms.isEnergyGuardLicenseAvailable),
        mergeMap(() => shieldIconTranslation$.pipe(rxjsMap((text: any) => text.hasActiveAlarmTooltip))),
      );

      const hasNoActiveAlarm$ = of(energyMarker.alarms.alarmsCount).pipe(
        filter((alarms) => alarms <= 0 && energyMarker.alarms.isEnergyGuardLicenseAvailable),
        mergeMap(() => shieldIconTranslation$.pipe(rxjsMap((text: any) => text.hasNoActiveAlarmWithLicenseTooltip))),
      );

      const hasNoLicense$ = of(energyMarker.alarms.alarmsCount).pipe(
        filter(() => !energyMarker.alarms.isEnergyGuardLicenseAvailable),
        mergeMap(() => shieldIconTranslation$.pipe(rxjsMap(() => ''))),
      );

      merge(hasActiveAlarm$, hasNoActiveAlarm$, hasNoLicense$)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((text) => {
          buildingIconComponent.instance.tooltipText = text;
          buildingIconComponent.instance.isUnknownBuildingType = isNil(energyMarker.buildingTypeId);
          buildingIconComponent.instance.alarmCount = energyMarker.alarms.alarmsCount;
          buildingIconComponent.instance.hasLicensedMetersMunicipalityLvl = this.isMunicipalityEnergyGuardLicensed;
          buildingIconComponent.instance.isMeterLicensed = energyMarker.alarms.isEnergyGuardLicenseAvailable;
          buildingIconComponent.changeDetectorRef.detectChanges();
        });
    }
  }

  private navigateByMarkers(): void {
    if (this.mapStoreService.lampMarkers.length <= 0 && this.mapStoreService.consumerMarkers.length <= 0) {
      this.navigateByPostCode();
      return;
    }

    const fiteredLampMarkers = this.mapStoreService.lampMarkers.filter((a) => a._latlng.lat > 0 || a._latlng.lng > 0);
    const filteredConsumerMarkers = this.mapStoreService.consumerMarkers.filter((a) => a._latlng.lat > 0 || a._latlng.lng > 0);

    if (fiteredLampMarkers.length <= 0 && filteredConsumerMarkers.length <= 0) {
      this.navigateByPostCode();
      return;
    }

    const markers = concat(fiteredLampMarkers, filteredConsumerMarkers);
    const latLng = this.mapService.calculateForMedianMarker(markers);
    (this.mapStoreService.map as L.Map).setView(new L.LatLng(latLng.lat, latLng.lng), 15);
  }

  private navigateByPostCode(): void {
    const municipality = this.userMunicipalitiesService.currentMunicipality;
    this.addressSearchService
      .searchByMunicipality(municipality)
      .pipe(
        rxjsMap((x: any) => ({
          lat: x.features[0].geometry.coordinates[1],
          lng: x.features[0].geometry.coordinates[0],
        })),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((x: any) => {
        (this.mapStoreService.map as L.Map).setView(new L.LatLng(x.lat, x.lng), 15);
      });
  }

  public addressNavigate(latLng: any): void {
    if (latLng && !isNil(latLng.lat) && !isNil(latLng.lng)) {
      if (!isNil(this.pinLocationMarker)) {
        this.pinLocationMarker.remove();
      }
      const coords = new L.LatLng(latLng.lat, latLng.lng);
      this.pinLocationMarker = L.marker(coords, {
        icon: this.mapService.getPinLocationMarker(),
      }).addTo(this.mapStoreService.map as L.Map);
      (this.mapStoreService.map as L.Map).setView(coords, this.mapStoreService.zoom.maxZoom - 1);
    }
  }

  private getBuildingAlarmsByMunicipality(municipalityKey: string): Observable<ViewBuildingAlarmsExtendedInfo1Dto[]> {
    return isNil(this.authService.permissions.ENERGY_GUARD)
      ? of([])
      : this.alarmsService.getBuildingsAlarmByMunicipality(municipalityKey).pipe(catchError(() => of([])));
  }
}
